module.exports = __webpack_public_path__ + "static/media/matnrrd_2-579w.abaf85aa.png";